/* import __COLOCATED_TEMPLATE__ from './wordpress.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();